export enum Environments {
  Production = 'prod',
  NonProd = 'non-prod',
  Local = 'local',
  Training = 'training',
}
